import { SVGProps, Ref, forwardRef } from 'react';

export const HeartFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M12 6.586C7.636.357 0 2.952 0 8.952 0 13.952 7 18 12 21c5-3 12-7.048 12-12.048 0-5.697-7.636-8.595-12-2.366"
                fill="currentColor"
            />
        </g>
    </svg>
));
HeartFilledSize24Glyph.displayName = 'HeartFilledSize24Glyph';
